import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import Autocomplete from "@material-ui/lab/Autocomplete";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormHelperText,
  NativeSelect,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  // Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  //Fade,
  fade,
  Button,
  Grid,
  Breadcrumbs,
  Typography,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import MessageBox from "../../../components/MessageBox/MessageBox";
import UpdateGlAccount from "./UpdateGlAccount";
import DeleteGlAccount from "./DeleteGlAccount";
const useStyles = makeStyles((theme) => ({
        // modal: {
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        // },
        modal: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
      
          margin: "0 auto",
        },
        textField: {
          marginTop: "-15px",
        },
        paper: {
          backgroundColor: theme.palette.background.paper,
          border: "2px solid #000",
          boxShadow: theme.shadows[5],
          padding: theme.spacing(2, 4, 3),
          width: "400px",
          maxHeight: "100%",
          overflow: "auto",
        },
      }));
      
const GlAccount = () => {
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const [filterType, setFilterType] = useState("1");
  const [description, setDescription] = useState("");
  const [branch, setBranch] = useState("");
  const [address, setAddress] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [idno, setIdno] = useState("");
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [branchIdData, setBranchIdData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [branchidno, setBranchidno] = useState("");
  const [type, setType] = useState("");
  const classes = useStyles();

  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");
  const [btnAddDisabled, setBtnAddDisabled] = useState(false);
  const [msgType, setMsgType] = useState("success");
  const [displayView, setDisplayView] = useState(false);
  //console.log(format(dateRange.endDate, "yyyy/MM/dd/"));

  const selectBranchIdProps = {
    options: branchIdData,
    getOptionLabel: (option) => option.idno,
  };
   const accountType = [
    "Assets","Bank Account","Cost of Goods Sold","Expenses","Equity","Income","Liabilities"
   ]
   
  const selectCreditProps = {
    options: accountType,
    getOptionLabel: (option) => option,
  };
  const showModal = (message, type) => {
    setShowMsgBox(true);
    setMsgType(type); //success or warning
    setMsg(message);
    setTimeout(() => {
      setShowMsgBox(false);
      getGlAccountList();
    }, 2000)
};

  const getGlAccountList = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "gl_accounts_list",{
        params:{
        branch:get_cookies("branchidno"),
        }
      })
      .then(function (res) {
          
        // console.log("gl_account", res);
        setPosts(res.data[0]);
          setDataLoaded(true);
          
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const searchAccount = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "gl_accounts_list_filter",{
        branch:get_cookies("branchidno"),
        type:type == ""?"":type,
        name:description == ""?"":description,
      })
      .then(function (res) {
          
        console.log("gl_account_search", res);
        setPosts(res.data[0]);
          setDataLoaded(true);
          
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // Data Fetching
  useEffect(() => {
    // getBranchIdData();
    getGlAccountList();
    //data(); only load table data when user has searched //for Entity >> Customer
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);

  //button search
  const filterData = () => {
    setDataLoaded(false);
    searchAccount();
  };


  const save_entity = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves
    const formData = new FormData();
    formData.append("name", description);
    formData.append("type", type);
    formData.append("branch", get_cookies("branchidno"));

    await axios
      .post(process.env.REACT_APP_API_URL + "insert_gl_accounts_list", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        console.log(res);
        if(res.status == 201){
          setShowMsgBox(true);
          setMsg("Description Already Exist");
          setMsgType("warning");
          setTimeout(() => {
            setShowMsgBox(false);
            setDisplayView(true);
            setDescription('');
            setType('');
            // setBtnDisabled(false); // re-enable
            // history.push('/account/');
          }, 2000);
        }else{
          setShowMsgBox(true);
          setMsg("Added New Account");
          setMsgType("success");
          setTimeout(() => {
            
            setShowMsgBox(false);
            setDisplayView(true);
            setModalOpen(false);
            setDescription('');
            setType('');
            // setBtnDisabled(false); // re-enable
            // history.push('/account/');
          }, 2000);

        }

      })
      .catch(function (error) {
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  useEffect(() => {
    if ((filterType == "1" && description) || (filterType == "2" && type)) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [idno, description,branch, filterType]);

 

  const data = async () => {
    //get data from api (for table)
    // const res = await axios.get('http://127.0.0.1/jcphq_new/public/gl_tran_report', {
    // 	params:{
    // 		date_from:'2013/01/01/', //format(dateRange.startDate, "yyyy/MM/dd/")
    // 		date_to:'2014/12/01/',   //format(dateRange.endDate, "yyyy/MM/dd/")
    // 		account_type_id:'all', //glAccFilter
    // 		jc_u_idno:'DAVAOHQ',  //input text for branchidno
    // 	}
    // })
    //res.data.data because api data is wrapped in "data"
    // console.log(res.data.data[res.data.data.length - 1]); //get the last item (grandtotal object)
    // setPosts(res.data.data);
    //setDataLoaded(true);
  };
  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "acttype",
      label: "Account Type",
    },
    {
      name: "id",
      label: "Actions",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          let position_id = posts[dataIndex].id;
          let position_name = posts[dataIndex].position;
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_id}>
                <UpdateGlAccount showModal={showModal} data={posts[dataIndex]} />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_id}>
                <DeleteGlAccount showModal={showModal} data={posts[dataIndex]} />
              </Grid>
            </Grid>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    downloadOptions: {
      filename: "CustomerInfo.csv", //change filename of csv
    },
    // tableBodyHeight,
  };
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AccountBalanceIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/entity">
            <h2 className="header-title">Settings</h2>
          </NavLink>
          <Typography color="textPrimary">Gl Accounts</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={modalOpen}
            onClose={handleModalClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Add Gl Account</h2>
              <form action="" className={classes.root}>
                <div>
                  <TextField
                    id="outlined-full-width"
                    label="Description"
                    style={{ margin: 8 }}
                    placeholder="Enter Description"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={true}
                    variant="outlined"
                    onChange={(e) => {
                        setDescription(e.target.value);
                    }}
                  />
                </div>
                <div style={{ marginLeft: 8, width: "100%" }}>
                  {/* <TextField id="outlined-basic" label="Branch Id No" variant="outlined" placeholder="Branch Id No" inputProps={{ 'aria-label': 'User Name' }} value={branchidno} onChange={e => setBranchidno(e.target.value)}/> */}
                  <Autocomplete
                    {...selectCreditProps}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    className={classes.autoComplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Type"
                        margin="normal"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (!newValue == "" || !newValue == null) {
                        setType(newValue);
                      } else {
                        setType(null);
                      }
                    }}
                  />
                </div>
         
                <div className={classes.button}>
                  <Grid
                    container
                    spacing={1}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        onClick={handleModalClose}
                        className={classes.buttonMarginRight}
                      >
                        Close
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={type == "" || description ==""?true:false}
                        onClick={(e) => {
                          save_entity();
                        }}
                      >
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </Modal>
        </div>
        <div>
          <Grid container spacing={2} style={{ display: "flex" }}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
              <NativeSelect
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setType("");
                  setDescription("");
                }}
                inputProps={{
                  name: "GL Account",
                }}
              >
                <option value={1}>Search Name</option>
                <option value={2}>Search By Account Type</option>
              </NativeSelect>
            </Grid>
            {/* show specific input based on input */}
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              {filterType === "1" ? (
                <TextField
                  required
                  id="standard-required"
                  label="Description"
                  inputProps={{ "aria-label": "description" }}
                  value={description}
                  fullWidth={true}
                  onChange={(e) => setDescription(e.target.value)}
                  className={classes.textField}
                  error={description === ""}
                  helperText={description === "" ? "Required field" : " "}
                />
              ) :null}
              {filterType === "2" ? (
               <Autocomplete
               {...selectCreditProps}
               id="auto-complete"
               autoComplete
               includeInputInList
               className={classes.autoComplete}
               renderInput={(params) => (
                 <TextField
                   {...params}
                   label="Select Type"
                   margin="normal"
                   variant="outlined"
                 />
               )}
               onChange={(event, newValue) => {
                 if (!newValue == "" || !newValue == null) {
                   setType(newValue);
                 } else {
                   setType(null);
                 }
               }}
             />
              ) :null}

            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={1} xl={1}>
              <Button
                // disabled={btnDisabled}
                variant="contained"
                color="primary"
                style={{ marginBottom: "12px" }}
                onClick={() => {
                  filterData();
                }}
              >
                Search
              </Button>
            </Grid>
            <Grid
              item
              xs={11}
              sm={10}
              md={10}
              lg={2}
              xl={2}
              style={{ marginLeft: "auto" }}
            >
              <Button
                // disabled={btnDisabled}
                variant="contained"
                color="primary"
                style={{ marginBottom: "12px" }}
                onClick={() => {
                  handleModalOpen();
                }}
              >
                Add Gl Account
              </Button>
            </Grid>
          </Grid>
        </div>
        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MUIDataTable
            title={
              <div>
                <h3 className="header-title" style={{ color: "#339933" }}>
                  Gl Accounts
                </h3>
              </div>
            }
            data={posts}
            columns={columns}
            options={options}
            key={index => index}
          />
        )}
      </div>
    </div>
  );
};

export default GlAccount;

